import { createStyles, makeStyles, TextField, Theme } from '@material-ui/core';
import React from 'react';
import EditCommonLabel from './EditCommonLabel';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    elementPreview: { marginTop: theme.spacing(4), width: '70%' }
  })
);
interface EditDateProps {
  onUpdateElementLabel: (e: any) => void;
  label: string;
}

const EditDate = ({ onUpdateElementLabel, label }: EditDateProps) => {
  const classes = useStyles();
  return (
    <>
      <EditCommonLabel onChange={onUpdateElementLabel} value={label} />
      <TextField
        type="date"
        className={classes.elementPreview}
        disabled
        placeholder="Päivämääräkenttä"
      />
    </>
  );
};
export default EditDate;
